import React, { FC } from 'react'
import classNames from 'classnames'
import { GiveawayContent } from '@/views/PreSales/PreSalesGiveawayView/components/Content'
import { GiveawayFooter } from '@/views/PreSales/PreSalesGiveawayView/components/Footer/GiveawayFooter'
import { GiveawayHeader } from '@/views/PreSales/PreSalesGiveawayView/components/Header'
import { GiveawayModals } from '@/views/PreSales/PreSalesGiveawayView/components/Modals/GiveawayModals'
import { GiveawayTabs } from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/GiveawayTabs/GiveawayTabs'
import { FloatingButtons } from '@/views/PreSales/PreSalesGiveawayView/components/UI/FloatingButtons'
import { GiveawaySeo } from '@/views/PreSales/PreSalesGiveawayView/components/UI/GiveawaySeo'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'

export const GiveawayLayout: FC = () => {
  const { isScenePlayerOpen, theatricalSlug, scrollToTab, scrollToProducts, giveawayData, isActive } =
    useGiveawayContext()

  return (
    <div className={classNames(isScenePlayerOpen ? 'fixed' : 'static')} data-slug={theatricalSlug}>
      <GiveawaySeo />
      <GiveawayHeader />
      <GiveawayContent />
      <GiveawayTabs />
      <GiveawayFooter
        scrollToTab={scrollToTab}
        scrollToProducts={scrollToProducts}
        tabs={giveawayData.tabs}
        isActive={isActive}
      />
      <FloatingButtons />
      <GiveawayModals />
    </div>
  )
}
